import React from 'react';
import type { Difficulty } from '../types/api';

const STYLES: Record<Difficulty, string> = {
  easy: 'badge-green',
  medium: 'badge-amber',
  hard: 'badge-red',
};

// A lesson's level (easy, medium, hard), the same everywhere a lesson is listed.
const DifficultyBadge: React.FC<{ difficulty?: Difficulty | null }> = ({ difficulty }) => {
  if (!difficulty || !STYLES[difficulty]) return null;
  return (
    <span className={`badge ${STYLES[difficulty]}`}>
      {difficulty}
    </span>
  );
};

export default DifficultyBadge;
